import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import { api } from './api'
import * as actions from './actions'
import { getOrgId } from 'modules/org/selectors'

const getApiKeyForOrgEpic = (action$, { getState }) => {
  return action$
    .ofType(actions.getApiKeyForOrg.toString())
    .pluck('payload')
    .switchMap(() => {
      const orgId = getOrgId(getState())
      return api
        .getApiKeyForOrg(orgId)
        .map((response) => {
          if (!!response && !!response.length) {
            return actions.getApiKeyForOrgSuccess(response)
          } else {
            return actions.createApiKeyForOrg()
          }
        })
        .startWith(actions.getApiKeyForOrgPending(orgId))
        .catch(error => {
          return Observable.of(actions.getApiKeyForOrgFailed({ error, orgId }))
        })
    })
}

const createApiKeyForOrgEpic = (action$, { getState }) => {
  return action$
    .ofType(actions.createApiKeyForOrg.toString())
    .pluck('payload')
    .switchMap(() => {
      const orgId = getOrgId(getState())
      return api
        .createApiKeyForOrg(orgId)
        .map((response) => actions.createApiKeyForOrgSuccess(response))
        .startWith(actions.createApiKeyForOrgPending(orgId))
        .catch(error => {
          return Observable.of(actions.createApiKeyForOrgFailed({ error, orgId }))
        })
    })
}

export const epic = combineEpics(
  getApiKeyForOrgEpic,
  createApiKeyForOrgEpic
)


// WEBPACK FOOTER //
// ./src/modules/apiKey/epic.js